<axis-card id="outstandingCard">
  <axis-card-body>
    <h1 class="axis-h3">
      @if (isUimuiNonDigital()) {
        We have received your rejection of electronically selecting and signing your selection forms.
      } @else if (isPipEnabled) {
        UM/UIM Complete - Continue to Your PIP Coverage Selections
      } @else {
        Thank you for Completing the UM/UIM flow
      }
    </h1>
    @if (content) {
      <p
        class="_mtb-large"
        [innerHTML]="content"
      ></p>
    }

    @if (!isPipEnabled && note && !isUimuiNonDigital()) {
      <p>
        {{ note }}
      </p>
    }


    <button
      axis-button
      class="kind-secondary"
      [disabled]="downloadInProgress"
      (click)="downloadUIUMDocuments()"
    >
      <axis-icon
        icon="download"
        font="custom"
      ></axis-icon>
      <span class="axis-btn-icon-text"> Download UM/UIM Documents </span>
    </button>
    @if (downloadInProgress) {
      <axis-loading
        class="size-small"
        [isInline]="true"
        *ngIf="downloadInProgress"
      ></axis-loading>
    }
  </axis-card-body>
</axis-card>

@if (isPipEnabled && !this.uimuiBaseRulesService.isPlayground) {
  <axis-card
    class="_mt-large"
    id="continueCard"
  >
    <axis-card-body class="_display-flex _align-items-center _justify-content-start">
      <h1 class="axis-h3 _mb-small">Start PIP Coverage Selections</h1>
      <div class="axis-btn-wrapper _ml-auto">
        <div class="axis-btn-wrapper-right">
          <button
            axis-button
            class="kind-primary"
            (click)="onContinue()"
          >
            <span class="axis-btn-icon-text">Continue</span>
          </button>
        </div>
      </div>
    </axis-card-body>
  </axis-card>
}
